module.exports = __webpack_public_path__ + "static/media/team1.e7ec8f6a.jpg";